import { scrollToFormAndSelectProduct } from './form-cta.js';

document.addEventListener('pricing:cta', function (event) {
    scrollToFormAndSelectProduct(event.detail ?? {});
});
